import { PaperclipIcon } from '@langchain/untitled-ui-icons';

import { forwardRef } from 'react';

import { IconButton } from '@/design-system';

export const MultimodalButton = forwardRef<
  HTMLButtonElement,
  { icon?: React.ReactNode; label?: string; round?: boolean }
>((props, ref) => {
  const { icon, label, round = true, ...rest } = props;
  const Icon = icon ?? PaperclipIcon;

  return (
    <IconButton
      icon={Icon}
      label={label ?? 'Add multimodal content'}
      ref={ref}
      color="secondary"
      round={round}
      {...rest}
    />
  );
});
